/**
 * @generated SignedSource<<6552b7aa1e03a7b7ab692c7c4c2d8a2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topicCardFragment$data = {
  readonly items: ReadonlyArray<{
    readonly __id: string;
    readonly displayLink: string | null;
    readonly entityKey: string | null;
    readonly helpObjectType: string | null;
    readonly logo: string | null;
    readonly title: string | null;
  }> | null;
  readonly topicId: string | null;
  readonly topicName: string | null;
  readonly " $fragmentType": "topicCardFragment";
};
export type topicCardFragment$key = {
  readonly " $data"?: topicCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topicCardFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "topicName"
    },
    {
      "kind": "ScalarField",
      "name": "topicId"
    },
    {
      "concreteType": "HelpLayoutTopicItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "logo"
        },
        {
          "kind": "ScalarField",
          "name": "displayLink"
        },
        {
          "kind": "ScalarField",
          "name": "entityKey"
        },
        {
          "kind": "ScalarField",
          "name": "helpObjectType"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpLayoutTopic"
};

(node as any).hash = "a170162f291e4b6022384af02ae41de2";

export default node;
